export default __webpack_public_path__ + "static/media/icon-navigation-ham.b39cc9a5.svg";